var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNextArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 32.5,
    height: 32.5,
    rx: 16.25,
    fill: "#B30707"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 31.5,
    height: 31.5,
    rx: 15.75,
    stroke: "white",
    strokeOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8532 20.9141L17.6032 27.1641C17.4271 27.3402 17.1882 27.4391 16.9391 27.4391C16.6901 27.4391 16.4512 27.3402 16.2751 27.1641C16.0989 26.988 16 26.7491 16 26.5C16 26.2509 16.0989 26.0121 16.2751 25.8359L21.8618 20.2508L16.2766 14.6641C16.1894 14.5769 16.1202 14.4733 16.073 14.3594C16.0259 14.2455 16.0016 14.1233 16.0016 14C16.0016 13.8767 16.0259 13.7546 16.073 13.6406C16.1202 13.5267 16.1894 13.4232 16.2766 13.3359C16.3638 13.2487 16.4674 13.1796 16.5813 13.1324C16.6952 13.0852 16.8174 13.0609 16.9407 13.0609C17.064 13.0609 17.1861 13.0852 17.3001 13.1324C17.414 13.1796 17.5175 13.2487 17.6048 13.3359L23.8548 19.5859C23.942 19.6731 24.0113 19.7767 24.0585 19.8907C24.1056 20.0047 24.1299 20.1269 24.1297 20.2503C24.1296 20.3737 24.1051 20.4959 24.0576 20.6098C24.0102 20.7237 23.9407 20.8271 23.8532 20.9141Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/next-arrow.2d9a4b32efc001e89e138537a8904b32.svg";
export { ForwardRef as ReactComponent };